import { ProductOrBrand } from "./alternativeTypes";

export const fastFoodProducts: ProductOrBrand[] = [
  {
    name: "McDonald's",
    ownerCountry: "US",
    notAvailableIn: ["IS", "PL", "AL", "MK", "BA"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/McDonald%27s"],
  },
  {
    name: "Chipotle",
    ownerCountry: "US",
    availableIn: ["CA", "FR", "DE", "UK"],
    categories: ["fast-food", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Chipotle_Mexican_Grill"],
  },
  {
    name: "Burger King",
    ownerCountry: "OT", // Brazilians (3G Capital) own Canadian Restaurant Brands International
    notAvailableIn: ["AU", "IS"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Burger_King"],
  },
  {
    name: "Hungry Jack's",
    ownerCountry: "OT", // Brazilians (3G Capital) own Canadian Restaurant Brands International
    availableIn: ["AU"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Hungry_Jack%27s"],
  },
  {
    name: "Subway",
    ownerCountry: "US",
    notAvailableIn: ["UA", "HR", "MK", "AL", "BA"],
    categories: ["fast-food", "sandwiches"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Subway_(restaurant)"],
  },
  {
    name: "KFC",
    ownerCountry: "US",
    categories: ["fast-food", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/KFC"],
    notAvailableIn: ["NO"],
  },
  {
    name: "Pizza Hut",
    ownerCountry: "US",
    categories: ["fast-food", "pizza"],
    availableIn: [
      "NO", "SE", "FI", "LV", "LT", "PL",
      "CZ", "RO", "GR", "TR", "DE", "FR",
      "ES", "PT", "UK", "IE", "IS", "NL",
      "BE", "CA", "MX", "AU",
    ],
    sourceLinks: ["https://en.wikipedia.org/wiki/Pizza_Hut"],
  },
  {
    name: "Starbucks",
    ownerCountry: "US",
    categories: ["fast-food", "other-fast-food"],
    availableIn: [
      "UK", "DE", "FR", "ES", "PL", "IE",
      "CH", "NL", "RO", "IT", "GR", "CZ",
      "DK", "AT", "BE", "NO", "SE", "BG",
      "PT", "FI", "LU", "MT", "CA", "MX",
      "AU",
    ],
    sourceLinks: ["https://en.wikipedia.org/wiki/Starbucks"],
  },
  {
    name: "Domino's",
    ownerCountry: "US",
    categories: ["fast-food", "pizza"],
    availableIn: [
      "AT", "BE", "BG", "HR", "CZ", "DK",
      "EE", "FR", "DE", "GR", "IS", "IE",
      "IT", "LU", "LV", "LT", "MK", "MT",
      "NL", "NO", "PL", "PT", "RO", "ES",
      "SE", "CH", "UA", "UK", "CA", "MX",
      "AU",
    ],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Domino%27s_Pizza",
      "https://www.dominos.com/index.intl.html",
    ],
  },
  {
    name: "Dunkin' Donuts",
    ownerCountry: "US",
    categories: ["fast-food", "other-fast-food"],
    availableIn: ["MX", "DE", "UK", "ES", "BG"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Dunkin%27_Donuts"],
  },
  {
    name: "Baskin-Robbins",
    ownerCountry: "US",
    categories: ["fast-food", "other-fast-food"],
    availableIn: [
      "CA", "MX", "UK", "ES", "PT",
      "DK", "NL", "IE", "AT", "GR",
      "TR", "LT", "LV", "EE", "PL",
      "AU",
    ],
    sourceLinks: ["https://en.wikipedia.org/wiki/Baskin-Robbins"],
  },
  {
    name: "Quick",
    ownerCountry: "BE", // Partially owned by Burger King
    categories: ["fast-food", "burgers"],
    availableIn: ["BE", "FR", "LU"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Quick_(restaurant)"],
  },
  {
    name: "Aladin",
    ownerCountry: "BG",
    categories: ["fast-food", "burgers"],
    availableIn: ["BG"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Aladin_Foods"],
  },
  {
    name: "Nedelya",
    ownerCountry: "BG",
    categories: ["fast-food", "other-fast-food"],
    availableIn: ["BG", "RO"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Nedelya_(pastry_shop)"],
  },
  {
    name: "Pizza Lab",
    ownerCountry: "BG",
    categories: ["fast-food", "pizza"],
    availableIn: ["BG"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Pizza_Lab_(restaurant_chain)"],
  },
  {
    name: "Hesburger",
    ownerCountry: "FI",
    categories: ["fast-food", "burgers"],
    availableIn: ["FI", "EE", "LV", "LT", "BG", "RO", "UA"], // Only two in DE, one in PL
    sourceLinks: ["https://en.wikipedia.org/wiki/Hesburger"],
  },
  {
    name: "Apache Pizza",
    ownerCountry: "IE",
    categories: ["fast-food", "pizza"],
    availableIn: ["IE"], 
    sourceLinks: ["https://en.wikipedia.org/wiki/Apache_Pizza"],
  },
    
  {
    name: "Rolls",
    ownerCountry: "FI",
    categories: ["fast-food", "burgers"],
    availableIn: ["FI"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Rolls_(restaurant_chain)"],
  },
  {
    name: "Marie Blachère",
    ownerCountry: "FR",
    categories: ["fast-food", "sandwiches", "other-fast-food"],
    availableIn: ["FR"],
    sourceLinks: ["https://fr.wikipedia.org/wiki/Marie_Blachère"],
  },
  {
    name: "Brioche Dorée",
    ownerCountry: "FR",
    categories: ["fast-food", "sandwiches", "other-fast-food"],
    availableIn: ["FR", "CA"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Brioche_Dorée"],
  },
  {
    name: "La Mie Câline",
    ownerCountry: "FR",
    categories: ["fast-food", "sandwiches", "other-fast-food"],
    availableIn: ["FR"],
    sourceLinks: ["https://fr.wikipedia.org/wiki/La_Mie_câline"],
  },    
  {
    name: "O'Tacos",
    ownerCountry: "FR",
    categories: ["fast-food", "other-fast-food"],
    availableIn: ["FR", "BE", "ES", "DK", "NL", "PT"],
    sourceLinks: ["https://en.wikipedia.org/wiki/O%27Tacos"],
  },
  {
    name: "Hans im Glück",
    ownerCountry: "DE",
    categories: ["fast-food", "burgers"],
    availableIn: ["DE", "CH", "AT"],
    sourceLinks: ["https://hansimglueck-burgergrill.de/standort/"],
  },
  {
    name: "Frittenwerk",
    ownerCountry: "DE",
    categories: ["fast-food", "burgers"],
    availableIn: ["DE"],
    sourceLinks: ["https://frittenwerk.com"],
  },
  {
    name: "Ditsch",
    ownerCountry: "MX",
    categories: ["fast-food", "other-fast-food"],
    availableIn: ["DE"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Ditsch"],
  },
  {
    name: "Kochlöffel",
    ownerCountry: "DE",
    availableIn: ["DE", "TR"],
    categories: ["fast-food", "burgers", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Kochlöffel"],
  },
  {
    name: "Conieco",
    ownerCountry: "DE",
    availableIn: ["PL"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Kochlöffel"],
  },
  {
    name: "Nordsee",
    ownerCountry: "DE",
    availableIn: ["DE", "AT", "CH", "RO", "TR"],
    categories: ["fast-food", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Nordsee"],
  },
  {
    name: "Goody's",
    ownerCountry: "GR",
    categories: ["fast-food", "burgers"],
    availableIn: ["GR", "AU", "AL", "MK"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Goody%27s_Burger_House"],
  },
  {
    name: "Metro",
    ownerCountry: "IS",
    categories: ["fast-food", "burgers"],
    availableIn: ["IS"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Metro_(restaurant_chain)"],
  },
  {
    name: "Abrakebabra",
    ownerCountry: "IE",
    availableIn: ["IE"],
    categories: ["fast-food", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Abrakebabra"],
  },
  {
    name: "Telepizza",
    ownerCountry: "OT", // Spanish company, but owned by a columbian chain
    availableIn: ["ES", "UK", "PL"],
    categories: ["fast-food", "pizza"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Telepizza"],
  },
  {
    name: "Apache Pizza",
    ownerCountry: "OT", // Irish company, but owned by a columbian chain and Burger King
    availableIn: ["IE"],
    categories: ["fast-food", "pizza"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Apache_Pizza"],
  },
  {
    name: "Eddie Rocket's",
    ownerCountry: "IE",
    availableIn: ["IE"], // Only two locations in DE
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Eddie_Rocket%27s"],
  },
  {
    name: "Supermac's",
    ownerCountry: "IE",
    availableIn: ["IE"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Supermac%27s"],
  },
  {
    name: "Four Star Pizza",
    ownerCountry: "IE",
    availableIn: ["IE"], // Maybe UK too?
    categories: ["fast-food", "pizza"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Four_Star_Pizza"],
  },
  {
    name: "Spizzico",
    ownerCountry: "IT",
    availableIn: ["IT", "GR", "CH", "FR"],
    categories: ["fast-food", "pizza"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Spizzico"],
  },
  {
    name: "FEBO",
    ownerCountry: "NL",
    availableIn: ["NL"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/FEBO"],
  },
  {
    name: "New York Pizza",
    ownerCountry: "NO",
    headquarterIn: "NL",
    availableIn: ["NL", "BE", "DE"],
    categories: ["fast-food", "pizza"],
    sourceLinks: ["https://en.wikipedia.org/wiki/New_York_Pizza"],
  },
  {
    name: "Peppes Pizza",
    ownerCountry: "NO",
    availableIn: ["NO"],
    categories: ["fast-food", "pizza"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Peppes_Pizza"],
  },
  {
    name: "Big Bite",
    ownerCountry: "NO",
    availableIn: ["NO"],
    categories: ["fast-food", "sandwiches"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Big_Bite_Submarines"],
  },
  {
    name: "Cervecería 100 Montaditos",
    ownerCountry: "ES",
    availableIn: ["ES", "IT", "PT", "MX"],
    categories: ["fast-food", "sandwiches"],
    sourceLinks: [
      "https://en.wikipedia.org/wiki/Cervecer%C3%ADa_100_Montaditos",
    ],
  },
  {
    name: "Rodilla",
    ownerCountry: "ES",
    availableIn: ["ES"],
    categories: ["fast-food", "sandwiches"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Rodilla"],
  },
  {
    name: "Max Burgers",
    ownerCountry: "SE",
    availableIn: ["SE", "NO", "DK", "PL"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Max_Hamburgers"],
  },
  {
    name: "Jafs",
    ownerCountry: "NO",
    availableIn: ["NO"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://no.wikipedia.org/wiki/Jafs"],
  },
  {
    name: "Sibylla",
    ownerCountry: "FI",
    availableIn: ["SE", "FI"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Sibylla"],
  },
  {
    name: "Costa Express",
    ownerCountry: "US", // Owned by Coca-Cola
    availableIn: ["UK", "PL", "IE", "CZ", "ES", "BG", "LT", "FR", "HR", "PT"],
    categories: ["fast-food", "sandwiches"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Costa_Coffee"],
  },
  {
    name: "Greggs",
    ownerCountry: "UK",
    availableIn: ["UK"],
    categories: ["fast-food", "sandwiches"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Greggs"],
  },
  {
    name: "Chicken Cottage",
    ownerCountry: "UK",
    availableIn: ["UK", "BE", "IE", "IT"],
    categories: ["fast-food", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Chicken_Cottage"],
  },
  {
    name: "Morley's",
    ownerCountry: "UK",
    availableIn: ["UK"],
    categories: ["fast-food", "burgers", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Morley%27s"],
  },
  {
    name: "Wasabi",
    ownerCountry: "UK",
    availableIn: ["UK"],
    categories: ["fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Wasabi_(restaurant)"],
  },
  {
    name: "YO! Sushi",
    ownerCountry: "UK",
    availableIn: ["UK", "AU"],
    categories: ["fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/YO!_Sushi"],
  },
  {
    name: "Caffe Nero",
    ownerCountry: "UK", // Multiple owners, known ones from UK and Luxembourg
    availableIn: ["UK", "IE", "PL", "SE", "HR", "TR"],
    categories: ["fast-food", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Caff%C3%A8_Nero"],
  },
  {
    name: "Tim Hortons",
    ownerCountry: "OT", // Canadian company, but owned by a Brazilian company
    availableIn: ["CA", "UK", "ES", "MX"],
    categories: ["fast-food", "sandwiches"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Tim_Hortons"],
  },
  {
    name: "A&W",
    ownerCountry: "CA", // Privately owned
    availableIn: ["CA"],
    categories: ["fast-food", "burgers"],
    sourceLinks: ["https://en.wikipedia.org/wiki/A%26W_(Canada)"],
  },
  {
    name: "Dairy Queen",
    ownerCountry: "US",
    availableIn: ["CA", "MX"],
    categories: ["fast-food", "other-fast-food"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Dairy_Queen"],
  },
  {
    name: "Little Caesars",
    ownerCountry: "US",
    availableIn: ["CA", "MX", "ES", "PT", "TR", "UK"],
    categories: ["fast-food", "pizza"],
    sourceLinks: ["https://en.wikipedia.org/wiki/Little_Caesars"],
  },
  {
    name: "Harvey’s",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "Established in 1959, Harvey’s is a Canadian fast-food chain known for its flame-grilled burgers that customers can customise with a variety of fresh toppings.",
    categories: ["fast-food", "burgers", "sandwiches"],
    sourceLinks: ["https://harveys.ca/"],
  },
  {
    name: "Pizzaville",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "Pizzaville first opened its doors in 1963 with the aim to serve delicious food for people with a fast-paced lifestyle.",
    categories: ["fast-food", "pizza"],
    sourceLinks: ["https://www.pizzaville.ca/"],
  },
  {
    name: "Pizza Pizza",
    ownerCountry: "CA",
    availableIn: ["CA"],
    comments: "Pizza Pizza Ltd. is a Canadian pizza restaurant that first opened its doors in 1967 in Toronto, Ontario",
    categories: ["fast-food", "pizza"],
    sourceLinks: ["http://pizzapizza.ca/"],
  },
  {
    name: "Pita Pit",
    ownerCountry: "CA",
    availableIn: ["CA", "AU", ],
    comments: "Their pita sandwiches that were loaded with grilled meats and fresh vegetables and topped with zesty sauces were an instant hit.",
    categories: ["fast-food", "other-fast-food"],
    sourceLinks: ["https://pitapit.ca/"],
  },
  // Check out what's happening around the world at Pita Pit Australia, France, India, Ireland, Sweden, New Zealand, T&T, Croatia!
  // Only two location in Ireland: https://pitapit.ie/find-a-location/  
];